import { render, staticRenderFns } from "./TopUsers.vue?vue&type=template&id=5a38afea"
import script from "./TopUsers.vue?vue&type=script&lang=js"
export * from "./TopUsers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports